import type { DISPLAY_STYLE_OPTIONS } from "../components/Paywalls/Admin/PaywallsAdmin/FormModal/CheckoutTab/constants";

export const EMOJI_TYPE = {
  EMOJI: "emoji",
  CUSTOM: "custom",
  SHAPES: "shapes",
};

export interface ShapeIcon {
  emoji_type: (typeof EMOJI_TYPE)["SHAPES"];
  identifier: string;
}

export interface CustomIcon {
  emoji_type: (typeof EMOJI_TYPE)["CUSTOM"];
  filename: string;
  signed_id: string;
}

export interface EmojiIcon {
  emoji: string;
  emoji_type: (typeof EMOJI_TYPE)["EMOJI"];
}

export type BadgePropertyIcon = EmojiIcon | CustomIcon | ShapeIcon;

export interface BadgeProperty {
  background_color: string;
  icon: BadgePropertyIcon;
  id?: string;
  label: string;
  text_color: string;
  visible: boolean;
}

export interface TestimonialProperty {
  avatar_image?: string;
  avatar_image_url?: string;
  display_style: {
    color: string;
    type: (typeof DISPLAY_STYLE_OPTIONS)[keyof typeof DISPLAY_STYLE_OPTIONS];
  };
  headline: string;
  id?: string;
  name: string;
  quote: string;
  visible: boolean;
}

export interface PaywallCustomization {
  badge_properties: {
    enabled: boolean;
    badges: BadgeProperty[];
  };
  community_id?: number;
  cover_image: string;
  cover_image_url: string;
  created_at?: string;
  id?: number;
  paywall_id?: number;
  testimonial_properties: {
    enabled: boolean;
    testimonials: TestimonialProperty[];
  };
  updated_at?: string;
}
